import { useEffect, useState } from "react";
import { string } from "prop-types";
import Button from "../Button/Button.jsx";
import cx from "classnames";

const propTypes = {
  btnText: string,
};

const upArrow = (
  <svg
    className="icon icon--up-arrow"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 5.95 6.06"
  >
    <path
      d="M5.85 2.6L3.35.15 3.23.07A.55.55 0 002.95 0a.59.59 0 00-.26.07l-.08.08L.11 2.6a.35.35 0 000 .5.35.35 0 00.5 0l2-2v4.6a.35.35 0 00.34.36.34.34 0 00.34-.34v-4.6l2 2a.36.36 0 00.51 0 .37.37 0 00.05-.52z"
      fill="currentcolor"
    />
  </svg>
);

const BackToTop = (props) => {
  const { btnText } = props;
  const [isActive, setBtnState] = useState(false);

  useEffect(() => {
    const toggleBackToTop = (event) => {
      if (window.pageYOffset > 150) {
        setBtnState(true);
      } else {
        setBtnState(false);
      }
    };

    window.addEventListener("scroll", toggleBackToTop);

    return () => {
      window.removeEventListener("scroll", toggleBackToTop);
    };
  }, []);

  const handleBtnClick = (event) => {
    event.preventDefault();
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={cx("back-to-top", { "back-to-top--is-active": isActive })}>
      <Button onClick={handleBtnClick} className="btn--primary">
        {btnText}
        <span className="btn__icon">{upArrow}</span>
      </Button>
    </div>
  );
};

BackToTop.propTypes = propTypes;
export default BackToTop;
